import { render, staticRenderFns } from "./myBreadcrumb.vue?vue&type=template&id=45aa1fe7&scoped=true&"
import script from "./myBreadcrumb.vue?vue&type=script&lang=js&"
export * from "./myBreadcrumb.vue?vue&type=script&lang=js&"
import style0 from "./myBreadcrumb.vue?vue&type=style&index=0&id=45aa1fe7&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45aa1fe7",
  null
  
)

export default component.exports